import gql from "graphql-tag";

export const ABORT_WAITING_SHIPMENT_REQUEST = gql`
  mutation abortWaitingShipmentRequests {
    abortWaitingShipmentRequests
  }
`;
